import { graphql } from '@/gql';
import { queryExecute } from '@/Utils/graphqlAPI';
import type { GrocerySearchItem } from '@/models/grocery';

// Fragments
import './fragments/grocerySearchItemRowFragment';

export const searchGroceryReplacementItems = async (itemId: string, country: string) => {
  const response = await queryExecute({
    fetchPolicy: 'no-cache',
    variables: {
      itemId,
      country,
    },
    query: graphql(`
      query SearchGroceryReplacementItems($itemId: String!, $country: String!) {
        searchGroceryReplacementItems(itemId: $itemId, country: $country) {
          ...GrocerySearchItemRowFragment
        }
      }
    `),
  });

  return response.data.searchGroceryReplacementItems as GrocerySearchItem[];
};
